import React, { ReactType } from 'react';
import './styles.scss';

import IconBox from '../IconBox';


interface IOptions {
  id: string | number;
  label: string;
  Icons: {
    id: string
    Icon: ReactType
  }[];
};


interface IPropType {
  options: IOptions[];
  selectedId?: string | number;
  //I know. I will revisit this later
  onClick?: any;
};



export default function IconBoxSelect({options, onClick, selectedId}: IPropType) {
  const handleOnClick = (id,label) => {
    onClick({id,label})
  }
  return (
    <div className='icon-box-container'>
      {options.map(({id, label, Icons}) => (
        <IconBox 
        key={id}
        id={id}
        label={label}
        Icons={Icons}
        onClick={() =>  handleOnClick(id,label)}
        active={selectedId === id}
        />
      ))}
    </div>
  )
}
